import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { UnconfirmedLoginPromptComponent } from './components/unconfirmed-login-prompt/unconfirmed-login-prompt.component';
import { QuestionnaireUserPromptComponent } from './components/questionnaire-user-prompt/questionnaire-user-prompt.component';
import { LoginComponent } from './components/login/login.component';
import { NewSharedModule } from 'app/new_shared/new-shared.module';
import { PipesModule } from 'app/modules/pipes/pipes.module';
import { AuthLayoutModule } from '../auth-layout/auth-layout.module';


@NgModule({
  declarations: [
    UnconfirmedLoginPromptComponent,
    QuestionnaireUserPromptComponent,
    LoginComponent,
  ],
  imports: [
    AuthLayoutModule,
    CommonModule,
    NewSharedModule,
    PipesModule,
    LoginRoutingModule
  ]
})
export class LoginModule { }
